module.exports = __webpack_public_path__ + "7af9fdd5cb28fe920cae000424836666.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1024.webp.png
// module id = 356
// module chunks = 0